/**
 * KundaktivitetSection - Visar kundens aktivitet på estimatet
 * 
 * Wrapper för CustomerActivityCard
 * Synlig endast när estimat är skickat
 */

import React from 'react';
import CustomerActivityCard from './CustomerActivityCard';

const KundaktivitetSection = ({ 
  activity,
  customerName,
  expanded, 
  onToggle,
  isVisible,
  onShowAllActivities
}) => {
  if (!isVisible) return null;

  return (
    <div className="bg-gray-50 rounded-lg shadow-sm border border-gray-200">
      {/* Header */}
      <div
        className="bg-gray-100 px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-200 transition-colors"
        onClick={onToggle}
      >
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-leadme-gray-dark">Kundaktivitet</h2>
          <svg
            className={`w-5 h-5 text-gray-500 transition-transform ${expanded ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {/* Content */}
      {expanded && (
        <div className="p-4 sm:p-6">
          <CustomerActivityCard 
            activity={activity}
            customerName={customerName}
            onShowAllActivities={onShowAllActivities}
          />
        </div>
      )}
    </div>
  );
};

export default KundaktivitetSection;

